import React from "react";

interface Props {
  width: number;
  height: number;
}

const SvgNewArrow = (props: Props) => (
  <svg
    {...props}
    viewBox="0 0 68 67"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3368_15967)">
      <circle cx="33.7447" cy="33.0743" r="33.3531" fill="#1F2126" />
      <path
        d="M40.7221 34.0569C41.2261 33.553 41.2621 32.7583 40.8301 32.2128L40.7221 32.0916L30.8954 22.2648C30.3527 21.7221 29.4728 21.7221 28.93 22.2648C28.4261 22.7688 28.3901 23.5635 28.8221 24.109L28.93 24.2302L37.7745 33.0759L28.93 41.9183C28.4261 42.4223 28.3901 43.217 28.8221 43.7624L28.93 43.8837C29.434 44.3876 30.2287 44.4236 30.7742 43.9916L30.8954 43.8837L40.7221 34.0569Z"
        fill="#D2D2D3"
      />
      <mask
        id="mask0_3368_15967"
        maskUnits="userSpaceOnUse"
        x="28"
        y="21"
        width="14"
        height="24"
      >
        <path
          d="M40.7221 34.0569C41.2261 33.553 41.2621 32.7583 40.8301 32.2128L40.7221 32.0916L30.8954 22.2648C30.3527 21.7221 29.4728 21.7221 28.93 22.2648C28.4261 22.7688 28.3901 23.5635 28.8221 24.109L28.93 24.2302L37.7745 33.0759L28.93 41.9183C28.4261 42.4223 28.3901 43.217 28.8221 43.7624L28.93 43.8837C29.434 44.3876 30.2287 44.4236 30.7742 43.9916L30.8954 43.8837L40.7221 34.0569Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_3368_15967)"></g>
    </g>
    <defs>
      <clipPath id="clip0_3368_15967">
        <rect
          width="66.7062"
          height="66.7062"
          fill="white"
          transform="translate(0.744629 0.0742798)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SvgNewArrow;
